<template>
  <modal v-on:closeModalRequest="closeModalRequest()">
    <div class="modal-change-password scrollable -y">
      <div class="header">
        <div class="title">Reset Your Password</div>
        <div v-if="isToResetPassword" class="description">You have automatically generated password. We recommend you to change the password.</div>
        <div v-else-if="lastPasswordReset" class="description">You have reset your password at {{lastPasswordReset}}</div>
      </div>
      <transition name="text" mode="out-in" appear>
        <div
        v-if="message"
        v-bind:class="{
          error: !isSuccess
        }"
        class="message">{{message}}</div>
      </transition>
      <form
      v-on:submit="onClickSubmit"
      class="body">
        <div class="content">
          <div class="action-btns flex-end">
            <div
            v-on:click="closeModalRequest()" ontouchstart=""
            class="action-btn">Cancel</div>
            <input
            id="update-new-password"
            type="submit" value="Request to reset your password"
            class="action-btn blue" />
          </div>
        </div>
      </form>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/Modal'
export default {
  name: 'modal-change-password',
  components: {
    Modal
  },
  computed: {
    isToResetPassword: function () {
      return this.$store.getters.isToResetPasswordAuth0 && (this.$store.getters.accountCreatedDate > this.$store.getters.newAccountLogicBeginDate)
    },
    lastPasswordReset: function () {
      return new Date(this.$store.getters.lastPasswordReset).toString()
    },
    statusSendPasswordResetEmail: function () {
      return this.$store.getters.statusSendPasswordResetEmail
    }
  },
  data: function () {
    return {
      message: null,
      isSuccess: true
    }
  },
  created: function () {
    this.getUserInfo()
  },
  beforeDestroy: function () {
    this.getUserInfo()
  },
  methods: {
    closeModalRequest: function () {
      this.$emit('closeModalRequest')
    },
    onClickSubmit: function (e) {
      e.preventDefault()
      if (this.statusSendPasswordResetEmail === 'requested') {
        this.$logger.warn('Still in requesting to send the password reset email.')
      } else {
        this.message = null
        this.isSuccess = true
        this.changePassword().then(
          resp => {
            this.message = resp
            this.isSuccess = true
            // setTimeout(() => { this.closeModalRequest() }, 5000)
          },
          err => {
            this.message = err.statusText + ': ' + err.description
            this.isSuccess = false
          }
        )
      }
    },
    changePassword: function () {
      return this.$store.dispatch('changePassword')
    },
    getUserInfo: function () {
      return this.$store.dispatch('getUserInfo')
    }
  }
}
</script>

<style scoped>
.modal-change-password {
  /* common */
  background-color: hsla(0, 100%, 100%, 1);
  font-size: 11px;
  border-radius: 5px;
  /* size */
  max-width: 500px;
  max-height: 100%;
  width: 100%;
}

.modal-change-password .header {
  /* common */
  font-size: 14px;
  /* size */
  padding: 20px 32px 20px;
  /* text */
  font-weight: bold;
  /* alignment */
  text-align: left;
}
.modal-change-password .header .title {
  /* common */
  font-size: 2em;
}
.modal-change-password .header .description {
  /* common */
  font-size: 1em;
  /* text */
  font-weight: normal;
}


.modal-change-password .message {
  /* common */
  background-color: hsla(202, 100%, 50%, 1);
  color: #fff;
  /* text */
  text-transform: uppercase;
  font-weight: bold;
  /* size */
  width: calc(100% - 2em);
  /* height: 3em; */
  padding: 1em;
  /* alignment */
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.modal-change-password .message.error {
  /* common */
  background-color: hsla(0, 100%, 65%, 1);
  color: #fff;
}


.modal-change-password .body {
  /* size */
  padding: 0 32px;
  /* border */
  border-top: 1px solid hsla(0, 100%, 0%, 0.1);
  /* alignment */
  text-align: left;
}

.modal-change-password .body .content {
  /* common */
  color: #000;
  font-size: 16px;
  /* size */
  width: 100%;
  min-height: 4em;
  margin: 16px 0;
  /* border */
  /* outline: 1px solid red; */
}



.modal-change-password .body .content .action-btns {
  /* size */
  margin: 1em 0 2em;
  /* alignment */
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.modal-change-password .body .content .action-btn.dark {
  /* common */
  background-color: hsla(202, 0%, 10%, 1);
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/Modal/ModalChangePassword.vue